import { UIButton, UICheckButton, UIControl, UILabel, UIView, UIViewController, UIViewControllerTransitioningDelegate, _CAAnimationType, _CAClassListForAnimationType, UIApplication } from "uikit";
import { BookingProductCategoryViewController } from "./BookingProductCategoryViewController";
import { BookingProductViewController, BookingProductProtocolDelegate } from "./BookingProductViewController";
import { BookingCalendarViewController, BookingCalendarProtocolDelegate } from "./BookingCalendarViewController";
import { BookingRestaurantViewController, BookingRestaurantProtocolDelegate } from "./BookingRestaurantViewController";
import { BookingClientProtocolDelegate, BookingClientViewController } from "./BookingClientViewController";
import { BookingSummaryViewController } from "./BookingSummaryViewController";
import { NSLocalizeString, NSObject } from "foundation";
import { MIOCoreGetPlatformLanguage, MIOStringWithFormat, MIOCoreGetLanguages } from "mio-core";
import { DLDB, RIGHTS_URL } from "dldb";
import { MUIComboBox } from "muikit";
import { BookingReviewViewController } from "./BookingReviewViewController";
import { BookingPaxViewController } from "./BookingPaxViewController";
import { StepViewProtocol } from "./StepView";
import { AppDelegate } from "../AppDelegate";


export class BookingViewController extends UIViewController implements BookingCalendarProtocolDelegate, BookingRestaurantProtocolDelegate, BookingClientProtocolDelegate
{
    protected errorLbl            : UILabel         = null ;
    private   payLoading          : UIView          = null ;

    private   languageComboBox    : MUIComboBox     = null ;

    private   acceptTermsCB       : UICheckButton   = null ;
    private   acceptPrivacyCB     : UICheckButton   = null ;
    private   acceptPublicityCB   : UICheckButton   = null ;
    private   acceptTermsLbl      : UILabel         = null ;
    private   acceptPrivacyLbl    : UILabel         = null ;
    private   bookButton          : UIButton        = null ;
    private   reviewButton        : UIButton        = null ;

    protected productCategoryViewController:BookingProductCategoryViewController = null;
    protected productViewController:BookingProductViewController = null;
    protected paxViewController:BookingPaxViewController = null;
    protected calendarViewController:BookingCalendarViewController = null;
    protected restaurantViewController:BookingRestaurantViewController = null;
    protected clientViewController:BookingClientViewController = null;

    protected stepViewControllers: StepViewProtocol[] = [];

    viewDidLoad ( )
    {
        super.viewDidLoad();            

        if ( this.languageComboBox ) {
            this.languageComboBox.hidden = false ;
            this.languageComboBox.addTarget( this, this.onLanguageChange, UIControl.Event.valueChanged);
            this.setupLanguageComboBox();
        }

        if ( this.acceptPrivacyLbl )
             this.acceptPrivacyLbl.text = MIOStringWithFormat( NSLocalizeString( "ACCEPT PRIVACY", "ACCEPT PRIVACY" ), DLDB.shared.getURL( RIGHTS_URL.PRIVACY ) ) ;
             
        if ( this.acceptTermsLbl )
             this.acceptTermsLbl.text = MIOStringWithFormat( NSLocalizeString( "ACCEPT TERMS", "ACCEPT TERMS" ), DLDB.shared.getURL( RIGHTS_URL.TERMS ) ) ;

        if ( this.acceptTermsCB )
            this.acceptTermsCB.addTarget( this, this.onAcceptedCheck, UIControl.Event.touchUpInside );

        if ( this.acceptPrivacyCB)
            this.acceptPrivacyCB.addTarget( this, this.onAcceptedCheck, UIControl.Event.touchUpInside );

        if ( this.acceptPublicityCB)
            this.acceptPublicityCB.addTarget( this, this.onAcceptedCheck, UIControl.Event.touchUpInside );

        this.errorLbl.setHidden(true);
        this.setLoading(false);

        if (this.bookButton) {
            this.bookButton.addTarget(this, this.onBooking, UIControl.Event.touchUpInside);
            this.bookButton.enabled = false;
        }

        if (this.reviewButton) {
            this.reviewButton.addTarget(this, this.onReview, UIControl.Event.touchUpInside);
            this.reviewButton.enabled = false;
        }
      }
      
    viewDidAppear ( animated: boolean ) {
        super.viewDidAppear(animated);
        this.checkBookBtn();
    }

    setupLanguageComboBox() {
        let platformLang = MIOCoreGetPlatformLanguage();
        let langOptions = MIOCoreGetLanguages();

        let i = 0;
        for (let key in langOptions) {
            this.languageComboBox.addItem(key, i);
            i++;
        }
    }

    onLanguageChange = ( ) => {
        //implement change of language here
    }

    onAcceptedCheck = ( ) =>
    {
        (UIApplication.shared.delegate as AppDelegate).dryRunCheck = false;
        this.checkBookBtn( ) ;
    }

    checkBookBtn = (  ) =>
    {        
        const bookBtn = this.bookButton ;

       if ( bookBtn ) {
            let v = this.acceptTermsCB.on && this.acceptPrivacyCB.on;            
            if (this.calendarViewController) v = v && this.calendarViewController.check(  );
            if (this.clientViewController) v = v && this.clientViewController.check(  );
            bookBtn.enabled = v;
       }

        const reviewBtn = this.reviewButton ;

        if ( reviewBtn ) {
            let v = true;
            if (this.productViewController) reviewBtn.enabled = reviewBtn.enabled && this.productViewController.check(  );
            if (this.calendarViewController) reviewBtn.enabled = reviewBtn.enabled && this.calendarViewController.check(  );
            if (this.restaurantViewController) reviewBtn.enabled = reviewBtn.enabled && this.restaurantViewController.check(  );
            reviewBtn.enabled = v;
        }
    }


    private onBooking ( )
    {
       const c1 = this.clientViewController.check( )
           , c2 = this.restaurantViewController.check( )
           , c3 = this.calendarViewController.check( ) ;

       if ( c1 && c2 && c3 )
         {
            const { comments, ...client } = (this.clientViewController) ? this.clientViewController.asJSON() : null
                , booking = (this.restaurantViewController) ? this.restaurantViewController.asJSON() : null
                , calendar = (this.calendarViewController) ? this.calendarViewController.asJSON() : null
                , hallComments = DLDB.shared.booking().hallComments
                , countryISO2 = DLDB.shared.booking().countryISO2 ?? ""
                , body =            
                  { id: DLDB.shared.booking().id.UUIDString
                  , comments
                  , hallComments
                  , nationalities: countryISO2
                  , client
                  , ...booking
                  , ...calendar 
                  , language: MIOCoreGetPlatformLanguage()
                  , acceptTerms: this.acceptTermsCB.on
                  , acceptPrivacy: this.acceptPrivacyCB.on
                  , acceptPublicity: this.acceptPublicityCB.on
                  } ;
            
            

            this.setLoading( true ) ;
            DLDB.shared.book( body, (code, res) =>
            {
              this.setLoading( false ) ;

              if ( code === 200 && res["error"] == null )
                {
                    const vc = BookingSummaryViewController.newInstance( res.data.identifier != null )
                    this.presentViewController(vc, true);

                    this.reset();
                }
              else 
                {
                   let error = (res.error || "").replace( "[BookingApiError] ", "" );
                   this.errorLbl.text = NSLocalizeString(error, error) ;
                   this.errorLbl.setHidden( false ) ;
                }
            } ) ;
         }

      return false ;
   }

   private onReview ( )
   {
       const c1 = this.productViewController.check( )
           , c2 = this.restaurantViewController.check( )
           , c3 = this.calendarViewController.check( ) ;

        if ( c1 && c2 && c3 ) {
            const vc = new BookingReviewViewController();
            vc.initWithNibName("BookingReviewView");
            this.presentViewController(vc, true);
        }
   }

    setLoading ( loading: boolean )
    {
        this.payLoading.hidden = !loading ;

        const btn = this.bookButton ;
        if ( btn ) btn.enabled = !loading ;
    }

    onNumProductDidChange ( vc: BookingProductViewController, numberOfProducts:number )
    {
        this.advanceStepIfNeeded( ) ;
        this.checkBookBtn( ) ;
    }

    onNumPeopleDidChange ( vc: BookingCalendarViewController, numberOfPeople:number )
    {
        this.advanceStepIfNeeded( ) ;
        this.checkBookBtn( ) ;
    }

    onCalendarDidChange ( vc: BookingCalendarViewController, date:string )
    {
        this.advanceStepIfNeeded( ) ;
        this.checkBookBtn( ) ;
    }

    onTimeDidChange ( vc: BookingRestaurantViewController, time:string )
    {
        this.advanceStepIfNeeded( ) ;
        this.checkBookBtn( ) ;
    }

    onClientFormDidChange ( vc: BookingClientViewController )
    {
        this.advanceStepIfNeeded( ) ;
        this.checkBookBtn( ) ;
    }

    private _nextStepIndex = 0 ;
    private _stepAdvancedForIndex: Set<number> = new Set();

    /**
     * Advances to the next step only once per step index.
     * Prevents multiple delegate callbacks from advancing the step multiple times.
     */
    private advanceStepIfNeeded ( ) {
        const nextIndex = this._nextStepIndex + 1;

        // Only advance if we haven't already advanced from this step
        if ( !this._stepAdvancedForIndex.has( this._nextStepIndex ) ) {
            this._stepAdvancedForIndex.add( this._nextStepIndex );
            this.nextStep( nextIndex ) ;
        }
    }

    private nextStep ( index: number = null ) { return;
        if ( index != null ) this._nextStepIndex = index ;
        else this._nextStepIndex = this._nextStepIndex++ ;

        for ( let i = 0 ; i < this.stepViewControllers.length ; i++ ) {
            if ( this.stepViewControllers[i] == null ) continue ;
            if ( i === this._nextStepIndex ) {
                this.stepViewControllers[i].stepView.selected = true;
            }
            else {
                this.stepViewControllers[i].stepView.selected = false;
            }
        }
    }

    public clear() {
        this.acceptPrivacyCB.selected = false;
        this.acceptTermsCB.selected = false;
        this.acceptPublicityCB.selected = false;

        this.acceptPrivacyCB.on = false;
        this.acceptTermsCB.on = false;
        this.acceptPublicityCB.on = false;

        this._stepAdvancedForIndex.clear();
        this.nextStep( 0 ) ;
    }

    public reset() {
        if (this.productViewController) this.productViewController.clear();
        if (this.calendarViewController) this.calendarViewController.clear();
        if (this.restaurantViewController) this.restaurantViewController.clear();
        if (this.clientViewController) this.clientViewController.clear();
        this.clear();
    }
}
